import { Link } from "react-router-dom";
import WorkCard from "@/components/feature/WorkCard";
import { allWorks } from "@/mocks/works";

const featured = allWorks
  .filter((work) => work.featured)
  .concat(allWorks.filter((work) => !work.featured))
  .slice(0, 8);

export default function FeaturedWorks() {
  return (
    <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-end justify-between">
        <div>
          <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
            <span className="h-5 w-1 rounded-full bg-accent-500"></span>
            精选影视作品
          </h2>
          <p className="mt-1 text-xs text-foreground-500">最新上线与口碑热播，一次看过瘾</p>
        </div>
        <Link
          to="/category/movie"
          className="flex cursor-pointer items-center gap-0.5 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700"
        >
          全部作品
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div data-product-shop className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
        {featured.map((work) => (
          <WorkCard key={work.id} work={work} />
        ))}
      </div>
    </section>
  );
}